const usePermissionConfig = () => {
  return {
    // 通知详情
    TZXQ: 'OPS-NRGL-TZGL-TZXQ',
    // 新增通知
    XZTZ: 'OPS-NRGL-TZGL-XZTZ',
    // 编辑
    BJ: 'OPS-NRGL-TZGL-BJ',
    // 撤销
    CX: 'OPS-NRGL-TZGL-CX',
    // 开始更新
    KSGX: 'OPS-NRGL-TZGL-KSGX',
    // 更新完成
    GXWC: 'OPS-NRGL-TZGL-GXWC',
  };
};

export default usePermissionConfig;
